import { 
    CHECK_INTEGRITY as SOCKET_CHECK_INTEGRITY,
    INITIATE_DB as SOCKET_INITIATE_DB
} from '../../events/DashboardToServer'

export const NO_MORE_SONG = 'NO_MORE_SONG'
export const NO_MORE_QUESTION = 'NO_MORE_QUESTION'
export const NO_MORE_SEVEN_WORDS = 'NO_MORE_SEVEN_WORDS'
export const NO_MORE_TWO_WORDS = 'NO_MORE_TWO_WORDS'
export const CHECK_INTEGRITY = 'CHECK_INTEGRITY'
export const DATABASE_CHECKED = 'CHECK_INTEGRITY'
export const INITIATE_DB = 'INITIATE_DB'
export const DATABASE_INITIATED = 'DATABASE_INITIATED'



export const miniDB = (state = [], action) => {
    switch (action.type) {

        case NO_MORE_SONG:
            var ss = {
                ...state,
            }
            ss.songAvailable = false
            return ss 

        case NO_MORE_QUESTION:
            var ss = {
                ...state,
            }
            ss.questionsAvailable = false
            return ss 

        case NO_MORE_SEVEN_WORDS:
            var ss = {
                ...state,
            }
            ss.sevenWordsAvailable = false
            return ss 
        
        case NO_MORE_TWO_WORDS:
            var ss = {
                ...state,
            }
            ss.twoWordsAvailable = false
            return ss 

        case DATABASE_CHECKED:
            var ss = {
                ...state,
            }
            ss.dbIntegrity = action.result
            return ss 

        case DATABASE_INITIATED:
            var ss = {
                ...state,
            }
            ss.songAvailable = action.result.songs > 0;
            ss.twoWordsAvailable = action.result.twoWords > 0;
            ss.sevenWordsAvailable = action.result.sevenWords > 0;
            ss.questionsAvailable = action.result.questions > 0;
            return ss 

        default:
            return state 
    }
}

export const noMoreSong = () => {
    return { type: NO_MORE_SONG}
}

export const noMoreQuestions = () => {
    return { type: NO_MORE_QUESTION}
}

export const noMoreSevenWords = () => {
    return { type: NO_MORE_SEVEN_WORDS}
}

export const noMoreTwoWords = () => {
    return { type: NO_MORE_TWO_WORDS}
}

export const checkIntegrity = (socket) => {
    socket.emit(SOCKET_CHECK_INTEGRITY)
    return { type: CHECK_INTEGRITY}
}

export const databaseChecked = (result) => {
    return { type: DATABASE_CHECKED, result}
}

export const initiateDB = (socket) => {
    socket.emit(SOCKET_INITIATE_DB)
    return { type: INITIATE_DB}
}

export const databaseInitiated = (result) => {
    return { type: DATABASE_INITIATED, result}
}







// WEBPACK FOOTER //
// ./src/reducers/miniDB/index.js